/**
 * Downloads an encoded document based on a document string
 */
export function downloadFile(documentString: string, fileName = 'data.csv') {
  const hiddenElement = document.createElement('a');

  hiddenElement.href = documentString;
  hiddenElement.target = '_blank';

  //provide the name for the CSV file to be downloaded
  hiddenElement.download = fileName;
  hiddenElement.click();
}
